
const letterNumberDict = {
    'b': 2,

    'c': 3,
    'v': 3,

    'd': 4,
    'e': 4,
    's': 4,
    't': 4,
    'u': 4,

    'g': 6,
    'h': 6,
    'i': 6,
    'x': 6,

    'j': 10,
    'k': 10,
    'z': 10,

    'l': 14,

    'm': 15,
    'n': 15,

    'a': 16,
    'o': 16,
    'p': 16,

    'q': 18,
    'r': 18,
    'w': 18,

    'y': 19,
    'f': 20,

    '0': 10,
    '1': 16,
    '2': 2,
    '3': 3,
    '4': 4,
    '5': 4,
    '6': 20,
    '7': 8,
    '8': 8,
    '9': 8,
}

// 16 is default color

export function convertLetterToColorNumber(letter:string|number) {

    letter = letter.toString().toLowerCase()

    return _.get(letterNumberDict,letter, 16)


}